// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"40b2bfe6","84":"53b8e8ed","149":"53b8e8ed","203":"40b2bfe6","238":"40b2bfe6","458":"4a796802","553":"9f62be9f","678":"8df7c38b"}[chunkId] + ".chunk.css";
};